import {closeAllFilters, showMobileFilters, mobileViewMenuNext, mobileViewReset} from './mobileView';
import {handleDesktopDropdown} from './desktopView';
import { handleSubnavBack, handleSubnavClear } from "./subnav";

const checkForConditionElseNullify = (condition: Boolean) =>
  (node:Node, clickFunction: Function, secondCondition:Boolean = false, secondClickFunction:Function) => {
    if(condition) {
      node.onclick = clickFunction;
    } else {
      if(secondCondition) {
        node.onclick = secondClickFunction;
      } else {
        node.onclick = null;
      }
    }
  };
/**
 * handleMobileViewMenu
 * init the event listener assignment on mobile view menu
 */
export function handleMobileViewMenu() {
  const plpViewMenu = document.getElementById("plp-view-menu");
  const megaFilters = document.getElementById("plp-filters-base");
  const bpMax01 = this;
  const resetButton = document.querySelector(".view-menu__top-reset-js");

  if (plpViewMenu === null || plpViewMenu === undefined) return;
  if (megaFilters === null || megaFilters === undefined) return;

  if (!bpMax01.matches) closeAllFilters(bpMax01);
  if (bpMax01.matches) closeAllFilters(bpMax01);

  const mobileBaseMenus = plpViewMenu.querySelectorAll(".view-menu-main__cta");
  const nextMenuBtns = plpViewMenu.querySelectorAll(".view-menu__cta--next");

  const subnavBackBtns = [
    ...plpViewMenu.querySelectorAll(".view-menu__subnav-btn--back"),
    ...megaFilters.querySelectorAll(".view-menu__subnav-btn--back"),
  ];

  const subnavClearBtns = [
    ...plpViewMenu.querySelectorAll(".view-menu__subnav-btn--clear"),
    ...megaFilters.querySelectorAll(".view-menu__subnav-btn--clear"),
  ];

  const checkForBpMax01 = checkForConditionElseNullify(bpMax01.matches);

  // assigns event listener to buttons if breakpoint matches
  // put event listener to show the full view menu on mobile
  mobileBaseMenus.forEach(mobileBaseMenu => {
    checkForBpMax01(
      mobileBaseMenu,
      showMobileFilters,
      mobileBaseMenu.classList.contains("view-menu-main__cta--desktop"),
      handleDesktopDropdown,
    )
  });

  // assign event handler for next menu buttons
  nextMenuBtns.forEach(nextMenuBtn => {
    checkForBpMax01(
      nextMenuBtn,
      mobileViewMenuNext,
      nextMenuBtn.classList.contains("view-menu-main__cta--desktop"),
      handleDesktopDropdown,
    )
  });

  // assign event handler for subnav back buttons
  // assign event handle for subnav back button on side filter
  subnavBackBtns.forEach(subnavBackBtn => {
    checkForBpMax01(subnavBackBtn, handleSubnavBack);
  });

  // assign event handler for subnav clear button
  // assign event handler for subnav clear button on side filters
  subnavClearBtns.forEach(subnavClearBtn => {
    checkForBpMax01(subnavClearBtn, handleSubnavClear);
  });
  resetButton.onclick = mobileViewReset;
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/plp-header/view/handleView.js